export const cssHelper = `
    <style>


    .table-box-fullproject-view{
        width: 100%;
        border-radius: 3px;
        padding: 0px 0px;
    }
    
    .table-box-fullproject-view h3 {
        font-size: 14px;
        color: #407CB1;
    }
    



    .table-box-fullproject h3{
        font-size: 14px;
        color: #60091d;
    }
    .table-box-fullproject{
        width: 100%;
        border-radius: 3px;
        margin-top: 0px;
        padding: 0px 0px;
    }
    
    .table-regression {
        width: 100%;
    }
    
    .table-regression thead {
        border-bottom: 1px solid #407CB1;
        text-align: center;
    
    }
    
    .table-regression thead tr th {
        font-size: 10px;
        color: #407CB1;
        padding-bottom: 4px;
        text-align: left;
    }
    
    .table-regression tbody tr  {
        border-bottom: 1px solid rgba(64, 124, 177, 1);
    }
    .table-regression tbody tr td {
        text-align: center;
        font-size: 10px;
        color: #407CB1;
        padding: 5px 0px;
        text-align: left;
        word-break:  break-word;
    }
    
    .table-regression tbody tr td:first-child {
        font-size: 10px;
        color: #407CB1;
        text-align: left;
        width: 29%;
    }
    
    .table-regression.first-row-bold tbody tr td:first-child {
        text-align: left;
    }
    
    
    .table-cis {
        width: 100%;
        margin-top: 30px;
    }
    
    .table-cis thead {
        border-bottom: 1px solid #407CB1;
        text-align: center;
    }
    
    .table-cis .title{
        font-size: 10px;
        color: #407CB1;
    }
    
    .table-cis .value{
        font-size: 10px;
        color: #407CB1;
    }
    
    .table-cis thead tr th {
        font-size: 10px;
        color: #407CB1;
        padding-bottom: 4px;
        text-align: left;
        padding-right: 5px;
    }
    
    .table-cis tbody tr td {
        text-align: center;
        font-size: 10px;
        color: #407CB1;
        border-bottom: 1px solid rgba(64, 124, 177, 1);
        padding: 5px 0px;
        text-align: left;
        word-break:  break-word;
    }
    
    .table-cis tbody tr td:first-child {
        width: 30%;
    }






    .table-box-fullproject-view .table-table {
        width: 100%;
        display: flex;
    }
    
    .table-box-fullproject-view .table-table tbody  {
        width: 100%;
        word-wrap: break-word;
    }
    
    .table-box-fullproject-view .table-table tbody tr {
        word-wrap: break-word;
        width: 100%;
    }
    
    .table-box-fullproject-view .table-table tbody tr td{
        word-wrap: break-word;
    }
    .table-box-fullproject-view .table-table thead tr {
        font-size: 10px;
        color: #407CB1;
        border-bottom: 2px solid #a3abb5;
        padding: 5px 0px;
    }
    .table-box-fullproject-view .table-table tr:nth-child(even){
        border-bottom: 1px solid rgba(64, 124, 177, 1);
        padding: 5px 0px;
        display: flex;
        align-items: center;
        min-height: 20px;
    
    }
    
    .table-box-fullproject-view .table-table tr:nth-child(odd){
        border-bottom: 1px solid rgba(64, 124, 177, 1);
        padding: 5px 0px;
        display: flex;
        align-items: center;
        min-height: 20px;
    
    }
    .table-box-fullproject-view .table-table .title {
        width: 290px;
        font-size: 10px;
        color: #407CB1;
    }
    .table-box-fullproject-view .table-table .value {
        width: 100%;
        font-size: 10px;
        color: #407CB1;
        word-wrap: break-word;
        word-break: break-all;
    }
    
    .table-box-fullproject-view .table-table .box {
        display: flex;
        align-items: center;
        flex-direction: row;
        height: 35px;
    }
    
    </style>
`;
